import { render, staticRenderFns } from "./formScreenPassport.vue?vue&type=template&id=84be4c58&scoped=true"
import script from "./formScreenPassport.vue?vue&type=script&lang=js"
export * from "./formScreenPassport.vue?vue&type=script&lang=js"
import style0 from "./formScreenPassport.vue?vue&type=style&index=0&id=84be4c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be4c58",
  null
  
)

export default component.exports